
import {
    HSCodeClassificationPage,
  } from 'src/views/cci/hscodeclassification'
  import pathMap from 'src/paths/pathMap'
  
  class CciHsCodeClassificationRoute {
    getConfigurations() {
      return [
        {
          exact: true,
          path: pathMap.CCI_HSCODE_CLASSIFICATION,
          component: HSCodeClassificationPage
        }
      ]
    }
  }
  
  export default CciHsCodeClassificationRoute